/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FluentLogLine } from './FluentLogLine';
import {
    FluentLogLineFromJSON,
    FluentLogLineFromJSONTyped,
    FluentLogLineToJSON,
} from './FluentLogLine';

/**
 * 
 * @export
 * @interface LogSessionPage
 */
export interface LogSessionPage {
    /**
     * 
     * @type {number}
     * @memberof LogSessionPage
     */
    id: number;
    /**
     * 
     * @type {Array<FluentLogLine>}
     * @memberof LogSessionPage
     */
    lines?: Array<FluentLogLine>;
    /**
     * 
     * @type {string}
     * @memberof LogSessionPage
     */
    back?: string;
    /**
     * 
     * @type {string}
     * @memberof LogSessionPage
     */
    tail?: string;
}

/**
 * Check if a given object implements the LogSessionPage interface.
 */
export function instanceOfLogSessionPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function LogSessionPageFromJSON(json: any): LogSessionPage {
    return LogSessionPageFromJSONTyped(json, false);
}

export function LogSessionPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogSessionPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lines': !exists(json, 'lines') ? undefined : ((json['lines'] as Array<any>).map(FluentLogLineFromJSON)),
        'back': !exists(json, 'back') ? undefined : json['back'],
        'tail': !exists(json, 'tail') ? undefined : json['tail'],
    };
}

export function LogSessionPageToJSON(value?: LogSessionPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lines': value.lines === undefined ? undefined : ((value.lines as Array<any>).map(FluentLogLineToJSON)),
        'back': value.back,
        'tail': value.tail,
    };
}

